import React from 'react';
import propTypes from 'prop-types';
import { Pie } from 'react-chartjs-2';
import { createChartData1, createChartData2 } from '../utils';

const LABELS = ['Passes', 'Needs Review', 'Failures'];
const COLORS = ['rgb(54, 208, 139)', '#ffbf00', 'rgb(224, 36, 90)'];

const createPieChartData = values => {
  const chartData = {
    datasets: [
      {
        data: [0, 0, 0],
        backgroundColor: COLORS,
      },
    ],
    labels: LABELS,
  };
  if (values) {
    chartData.datasets[0].data = values;
  }
  return chartData;
};

export const PieCharts = ({ data }) => {
  const pieChartData1 = createPieChartData(createChartData1(data));
  const pieChartData2 = createPieChartData(createChartData2(data));
  const options = {
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: context => {
            return ` ${Math.round(context.formattedValue * 100)}%`;
          },
        },
      },
    },
  };
  return (
    <div className="compliance-pie-charts-container">
      <div className="compliance-pie-chart-legend">
        {LABELS.map((label, i) => (
          <div key={i} className="compliance-pie-chart-legend-item">
            <div
              className="compliance-pie-chart-legend-item-color"
              style={{ backgroundColor: COLORS[i] }}
            />
            <div className="compliance-pie-chart-legend-item-label">
              {label}
            </div>
          </div>
        ))}
      </div>
      <div className="compliance-pie-charts">
        <div className="compliance-pie-chart">
          <Pie data={pieChartData1} options={options} />
          <div className="compliance-pie-chart-label">Before resolving</div>
        </div>
        <div className="compliance-pie-chart">
          <Pie data={pieChartData2} options={options} />
          <div className="compliance-pie-chart-label">After resolving</div>
        </div>
      </div>
    </div>
  );
};

PieCharts.propTypes = {
  data: propTypes.object,
};

PieCharts.defaultProps = {
  data: null,
};
